import React, { useState } from "react";
import RenderButton from "../common/button";

const Headder = ({ onChange }) => {
  const [r01, setr01] = useState("btn btn-primary");
  const [r02, setr02] = useState("btn btn-outline-dark");
  const [r03, setr03] = useState("btn btn-outline-dark");
  const [r04, setr04] = useState("btn btn-outline-dark");

  const handleonClick = ({ currentTarget: input }) => {
    if (input.value == "01") {
      disabledlabel();
      setr01("btn btn-primary");
    } else if (input.value == "02") {
      disabledlabel();
      setr02("btn btn-primary");
    } else if (input.value == "03") {
      disabledlabel();
      setr03("btn btn-primary");
    } else if (input.value == "04") {
      disabledlabel();
      setr04("btn btn-primary");
    }
    onChange(input.value);
  };
  // const handleChange = (date) => {
  //     setStartDate(date)
  //     handleDateChange(date);
  // }

  const disabledlabel = () => {
    setr01("btn btn-outline-dark");
    setr02("btn btn-outline-dark");
    setr03("btn btn-outline-dark");
    setr04("btn btn-outline-dark");
  };

  return (
    <div className="mt-2">
      <div className="btn-group" role="group">
        <RenderButton
          label="ตามสถานที่ลง"
          value="01"
          onClick={handleonClick}
          className={r01}
        />
        <RenderButton
          label="ตามวัตถุประสงค์"
          value="02"
          onClick={handleonClick}
          className={r02}
        />
        <RenderButton
          value="03"
          label="ตามชื่อลูกค้า"
          onClick={handleonClick}
          className={r03}
        />
        <RenderButton
          value="04"
          label="ตามชื่อสินค้า"
          onClick={handleonClick}
          className={r04}
        />

        {/* <RenderButton 
                           value="531"
                          label ="ปางสีดา"
                     onClick ={handleonClick}
                     className = {}
                      /> */}
      </div>
    </div>
  );
};

export default Headder;
